import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KenButton from '../KenButton';

export function ErrorFallback({ error, componentStack, resetErrorBoundary }) {
  // Log the underlying error so we can diagnose prerender failures (e.g., react-snap runs).
  // Sentry's ErrorBoundary overwrites the stack of the error it re-throws with the component
  // stack, so log the original error object as well - that is the one carrying the real frames.
  if (error) {
    // eslint-disable-next-line no-console
    console.error('Application error captured by ErrorBoundary', error, error?.stack, componentStack);
  }
  return (
    <Box role="alert" alignItems="center" justifyContent="center" display="flex" flexDirection="column">
      <Typography style={{ marginTop: 10 }}>Something went wrong</Typography>
      <KenButton onClick={resetErrorBoundary}>Click here to Refresh</KenButton>
    </Box>
  );
}
